module.exports = __webpack_public_path__ + "img/myposition_wb_호베르트 카를로스.ae761b59.png";